import React from 'react';
import {
  createStyles,
  Theme,
  withStyles,
  BoxProps,
  Box,
} from '@material-ui/core';
import FsBodySmallBold from 'ui-elements/typography/FsBodySmallBold';
import FsBodySmall from 'ui-elements/typography/FsBodySmall';
import FsBodyExtraSmall from 'ui-elements/typography/FsBodyExtraSmall';
import FsBody from 'ui-elements/typography/FsBody';
import FsCaption from 'ui-elements/typography/FsCaption';
import FsBodyBold from 'ui-elements/typography/FsBodyBold';
import { green } from 'globals/colors';

export const RowBox = withStyles(({ palette, spacing }: Theme) =>
  createStyles({
    root: {
      width: '100%',
      padding: spacing(0.75, 0),
      borderBottom: `1px solid ${palette.grey[200]}`,
      boxSizing: 'border-box',
    },
  })
)((props: BoxProps) => (
  <Box
    display="flex"
    alignItems="center"
    justifyContent="space-between"
    {...props}
  />
));

export const Date = withStyles(() => createStyles({}))((props) => (
  <FsBodySmall component="span" {...props} />
));

export const Name = withStyles(() => createStyles({}))((props) => (
  <FsBodySmallBold component="p" {...props} />
));

export const Description = withStyles(({ palette }) =>
  createStyles({
    root: {
      color: palette.grey[400],
    },
  })
)((props) => <FsBodyExtraSmall component="p" {...props} />);

export const Value = withStyles({})((props) => (
  <FsBody component="span" {...props} />
));

export const BalanceLabel = withStyles(({ palette }) =>
  createStyles({
    root: {
      fontSize: 10,
      textTransform: 'uppercase',
      color: palette.grey[300],
    },
  })
)((props) => <FsCaption component="p" {...props} />);

export const Balance = withStyles(() =>
  createStyles({
    root: {
      color: green.MAIN,
    },
  })
)((props) => <FsBodyBold component="span" {...props} />);
